import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

Fancybox.bind('.video[data-fancybox]', {
  defaultType: 'video',
});
